import { AxiosError } from 'axios';
import { api } from '@shared/api';
import { classifyVerifyError, type VerifyErrorCode } from '../model/confirmState';

export class EmailConfirmError extends Error {
  constructor(public code: VerifyErrorCode) {
    super(code);
    this.name = 'EmailConfirmError';
  }
}

/** Подтвердить почту по ссылке. Ошибки — см. classifyVerifyError (400 TOKEN_EXPIRED, 429, сеть). */
export async function verifyEmail(token: string): Promise<{ ok: true }> {
  try {
    await api.put('/auth/verify-user', { token });
    return { ok: true };
  } catch (err) {
    if (err instanceof AxiosError) {
      const res = err.response;
      const code = (res?.data as { error?: { code?: string } } | undefined)?.error?.code;
      throw new EmailConfirmError(classifyVerifyError(res ? { status: res.status, code } : null));
    }
    throw new EmailConfirmError('UNKNOWN');
  }
}
